export { default } from './RelationsAccount.vue'
